import React, { useId } from 'react';
import IProps from './interface';
import { colors } from 'crono-fe-common/theme';

export const IconTodo = ({
  color = colors.black,
  size = 16,
  className,
  ...props
}: IProps) => {
  const id = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M11.5 1L4 1C2.34315 1 1 2.34315 1 4L1 12C1 13.6569 2.34315 15 4 15L12 15C13.6569 15 15 13.6569 15 12V8"
          stroke={color}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 7L7.5 10L14.5 3"
          stroke={color}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width={16} height={16} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
